import hcAxios from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// 第三方账户接口
enum API {
  // 绑定第三方账户
  ThirdAccountBind = '/hk-web/third/account/bind',
  // 解绑第三方账户
  ThirdAccountUnbind = '/hk-web/third/account/unbind',
  // 第三方账户绑定列表
  ThirdAccountList = '/hk-web/third/account/list',
  // 第三方授权登录
  ThirdAccountLogin = '/hk-web/third/account/login',
}

export type TPostThirdAccountBindParams = {
  bizData?: string // 加密后的业务数据
  randomIv?: string // 随机向量
  randomKey?: string // 随机密钥
  signature?: string // 签名串
  timestamp?: number // 时间戳
}
export type TPostThirdAccountBindResponse = TResponse<any>
export const postThirdAccountBind = (params?: TPostThirdAccountBindParams) => {
  return hcAxios.post<TPostThirdAccountBindResponse>(API.ThirdAccountBind, params)
}

export type TPostThirdAccountUnbindParams = {
  bizData?: string // 加密后的业务数据
  randomIv?: string // 随机向量
  randomKey?: string // 随机密钥
  signature?: string // 签名串
  timestamp?: number // 时间戳
}
export type TPostThirdAccountUnbindResponse = TResponse<any>
export const postThirdAccountUnbind = (params?: TPostThirdAccountUnbindParams) => {
  return hcAxios.post<TPostThirdAccountUnbindResponse>(API.ThirdAccountUnbind, params)
}

export type TPostThirdAccountListParams = {
  bizData?: string // 加密后的业务数据
  randomIv?: string // 随机向量
  randomKey?: string // 随机密钥
  signature?: string // 签名串
  timestamp?: number // 时间戳
}
export type TPostThirdAccountListResponse = TResponse<string>
export const postThirdAccountList = (params?: TPostThirdAccountListParams) => {
  return hcAxios.post<TPostThirdAccountListResponse>(API.ThirdAccountList, params)
}

export type TPostThirdAccountLoginParams = {
  bizData?: string // 加密后的业务数据
  randomIv?: string // 随机向量
  randomKey?: string // 随机密钥
  signature?: string // 签名串
  timestamp?: number // 时间戳
}
export type TPostThirdAccountLoginResponse = TResponse<string>
export const postThirdAccountLogin = (params?: TPostThirdAccountLoginParams) => {
  return hcAxios.post<TPostThirdAccountLoginResponse>(API.ThirdAccountLogin, params, {
    options: {
      signature: 'decrypted',
    },
  })
}
